// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var IVotingType;
(function (IVotingType) {
    IVotingType["NON_PREFERENTIAL"] = "non-preferential";
    IVotingType["PREFERENTIAL"] = "preferential";
})(IVotingType || (IVotingType = {}));
